<div class="dropdown dot-mnu">
  <button
    class="dropdown-toggle"
    type="button"
    aria-expanded="false"
    [matMenuTriggerFor]="menu"
  >
    <app-dots-icon height="24px" width="24px" color="var(--gray-600)" />
  </button>
  <mat-menu #menu="matMenu">
    <ng-template matMenuContent>
      <button mat-menu-item (click)="openCustomerSupportModal()">
        <i class="bi bi-check-circle-fill"></i>
        <ng-container i18n>Chargé de clientèle</ng-container>
      </button>
    </ng-template>
  </mat-menu>
</div>
